/**
 * Persist Practice page settings to localStorage.
 * Shared between PracticeView (navigation) and PracticeListenTextView (display).
 * Each component reads/writes its own fields; updates are merged.
 */

import { PRACTICE_SETTINGS_STORAGE_KEY } from '@/constants/practiceConstants'

interface PracticeSettings {
  // Navigation (PracticeView)
  category: string | null
  itemTitle: string | null

  // Display (PracticeListenTextView)
  fontSize: number
  granularityIndex: number
  tikkunStyle: boolean
  transformationName: string
  uiPitchShift: number
}

function loadPracticeSettings(): Partial<PracticeSettings> {
  try {
    return JSON.parse(localStorage.getItem(PRACTICE_SETTINGS_STORAGE_KEY) ?? '{}')
  } catch {
    return {}
  }
}

function savePracticeSettings(updates: Partial<PracticeSettings>): void {
  const current = loadPracticeSettings()
  localStorage.setItem(PRACTICE_SETTINGS_STORAGE_KEY, JSON.stringify({ ...current, ...updates }))
}

export { loadPracticeSettings, PracticeSettings, savePracticeSettings }
